export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11249.cfda8765.jpg";